import React from 'react'
const AzureLogoWithText = (): JSX.Element => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 150 43.2"
      width="100%"
      height="100%"
      className="azure-logo-with-text"
    >
      <title>Azure Logo</title>
      <path
        id="path21"
        className="st0"
        d="M25.8,40.9c7.2-1.3,13.1-2.3,13.2-2.3l0.1,0l-6.8-8
	c-3.7-4.4-6.8-8.1-6.8-8.1c0,0,7-19.3,7-19.4c0,0,4.8,8.2,11.5,19.9c6.3,11,11.5,20,11.6,20.1l0.1,0.2l-21.5,0l-21.5,0
	C12.8,43.2,25.8,40.9,25.8,40.9z M108.3,39c-3.3-0.2-5.2-2.1-5.7-5.6c-0.1-0.9-0.1-1-0.1-7l0-5.8h1.4h1.4l0,5.6c0,5.1,0,5.7,0.1,6
	c0.2,1.5,0.6,2.4,1.3,3.1c0.5,0.6,1.2,0.9,2,1.1c0.4,0.1,1.6,0.1,1.9,0c0.9-0.2,1.6-0.6,2.2-1.2c0.7-0.7,1.2-1.7,1.5-2.8l0.1-0.4
	l0-5.7l0-5.7h1.5h1.5v8.9v8.9h-1.5h-1.5v-1.4c0-1,0-1.4,0-1.4c0,0-0.1,0.1-0.2,0.3c-0.5,0.9-1.3,1.8-2.3,2.3
	C110.9,38.8,109.8,39.1,108.3,39L108.3,39z M141.5,38.9c-1.2-0.1-2.4-0.5-3.4-1.1c-2.1-1.3-3.3-3.4-3.7-6.4c-0.1-1-0.1-2.4,0-3.2
	c0.2-1.9,1-3.8,2.1-5.2c0.3-0.3,0.9-1,1.3-1.3c0.9-0.7,2-1.3,3.2-1.5c0.7-0.1,1.9-0.2,2.6-0.2c1.8,0.2,3.5,1,4.6,2.4
	c1.1,1.4,1.8,3.3,1.9,5.6c0,0.4,0,1,0,1.4l0,0.8l-6.3,0l-6.3,0v0.3c0,0.9,0.2,1.8,0.6,2.7c0.3,0.7,0.8,1.5,1.3,1.9
	c0.9,0.8,2,1.2,3.2,1.4c0.4,0,1.6,0,2.1-0.1c1.5-0.2,2.8-0.8,4-1.6c0.1-0.1,0.3-0.2,0.3-0.2c0,0,0,0.2,0,1.3l0,1.3l-0.3,0.2
	c-1.3,0.8-2.7,1.3-4.2,1.5C143.7,39,142.1,39,141.5,38.9L141.5,38.9z M147,27.6c0-1.4-0.6-3-1.5-3.9c-0.6-0.6-1.4-0.9-2.2-1.1
	c-0.4-0.1-1.3,0-1.7,0c-0.9,0.2-1.7,0.6-2.4,1.3c-0.7,0.7-1.2,1.5-1.6,2.5c-0.1,0.3-0.3,0.9-0.3,1.2l0,0.2h4.9h4.9V27.6z M61,38.5
	c0,0,2.2-5.7,4.8-12.6l4.8-12.5l1.5,0l1.5,0l0.1,0.3c0.4,1,9.6,24.8,9.6,24.8c0,0-0.7,0-1.6,0l-1.6,0L78.7,35l-1.3-3.5l-5.3,0
	l-5.3,0l0,0.1c0,0.1-0.6,1.6-1.3,3.5l-1.2,3.4l-1.6,0C61.3,38.5,61,38.5,61,38.5L61,38.5z M76.4,28.8c0,0-0.9-2.4-2-5.4
	c-2-5.5-2.1-5.8-2.3-6.7c-0.1-0.4-0.1-0.4-0.2,0c0,0.3-0.2,0.9-0.3,1.2c-0.1,0.2-1,2.7-2,5.6c-1.1,2.9-1.9,5.3-1.9,5.3
	c0,0,2,0,4.3,0C74.5,28.8,76.4,28.8,76.4,28.8z M84.3,38.1v-0.5l5.3-7.3l5.3-7.3l-4.8,0l-4.8,0l0-1.2l0-1.2h6.9h6.9V21v0.4l-5.3,7.3
	c-2.9,4-5.3,7.3-5.3,7.3c0,0,2.4,0,5.2,0H99v1.2v1.2h-7.4h-7.4V38.1z M123.2,38.5c0,0,0-4.1,0-9v-9h1.4h1.4v1.8c0,1,0,1.8,0,1.8
	s0.1-0.2,0.2-0.4c0.3-0.9,0.9-1.8,1.6-2.5c0.7-0.6,1.4-1,2.3-1.1c0.2,0,0.5,0,1,0c0.6,0,0.9,0.1,1.3,0.2l0.1,0V22v1.5l-0.3-0.2
	c-0.6-0.3-1.2-0.4-1.9-0.4c-0.5,0-0.8,0.1-1.1,0.2c-0.8,0.3-1.4,0.8-1.8,1.5c-0.6,1-1.1,2.3-1.2,3.5c0,0.2,0,1.9,0,5.4l0,5.1h-1.4
	C123.8,38.5,123.2,38.5,123.2,38.5z M0,38.5c0,0,3.2-5.5,7.1-12.3l7.1-12.3l8.3-6.9C27,3.1,30.7,0,30.7,0c0,0,0,0.1-0.1,0.3
	c-0.1,0.2-4.1,8.8-9,19.2l-8.8,18.9l-6.4,0C2.9,38.5,0,38.5,0,38.5z"
      />
    </svg>
  )
}
export default AzureLogoWithText
